
<router-outlet ngxUiLoaderBlurred></router-outlet>
<ngx-ui-loader [fgsColor]="'red'" [pbColor]="'rgba(210,26,26,0.72)'" ></ngx-ui-loader>